import { Component, inject, input } from '@angular/core';
import { CartService } from '../../../../services/cart.service';
import { UmamiService } from '../../../../services/umami.service';

@Component({
    selector: 'app-cart-icon',
    imports: [],
    templateUrl: './cart-icon.component.html',
})
export class CartIconComponent {
    id = input.required<string>();
    cartService = inject(CartService);
    umami = inject(UmamiService);
}
